import React from "react";
import classNames from "classnames";
import { ActivityIcon } from "./ActivityIcon";
import styles from "./ActivityBadge.module.css";

export const ActivityBadge = ({ activity, className, ...props }) => {
  const { icon, label } = activity;

  return (
    <div
      className={classNames(
        styles.activityBadge,
        { [styles.noIcon]: icon === "offer" },
        className,
      )}
      {...props}
    >
      {icon && <ActivityIcon iconType={icon} label={label} size={16} />}
      <span className={styles.activityLabel}>{label}</span>
    </div>
  );
};
